import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import FloatingWhatsApp from "@/components/feature/FloatingWhatsApp";
import ScrollToTop from "@/components/feature/ScrollToTop";
import AnalyticsTracker from "@/components/feature/AnalyticsTracker";
import CookieBanner from "@/pages/home/components/CookieBanner";
import TrackingDebugPanel from "@/components/feature/TrackingDebugPanel";
import { initializeGoogleTags } from "@/utils/googleAnalytics";

function App() {
  useEffect(() => {
    // Idempotente: garante as tags ativas mesmo se algo atrasar no carregamento.
    initializeGoogleTags();
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <AnalyticsTracker />
        <AppRoutes />
        <FloatingWhatsApp />
        <CookieBanner />
        <TrackingDebugPanel />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;